import React from 'react';
import classes from "./MyTeam.module.css";
import { useDispatch } from 'react-redux';
import { togglePlayerPointsModal } from '../store/slices/playerPointsModalSlice';
import { useTranslation } from 'react-i18next';

const MyTeam = ({ attackers, midfielders, defenders, goalkeeper ,match_fixture_id}) => {
    const dispatch=useDispatch();

    const {t}=useTranslation();

    return (
        <>
            <div className={classes.line_up_container}>
                <div className={classes.line_up_sub_container}>
                    <img
                        src="/assets/images/football-ground-half.jpg"
                        alt="football ground"
                        className={classes.ground}
                    />

                    <div className={classes.sub_container}>
                        <div
                            className={classes.grid_container}
                            style={{
                                gridTemplateColumns: `repeat(${attackers.length}, 1fr)`,
                            }}
                        >
                            {attackers.map((data) => {
                                console.log(data,'da------');
                                return (
                                    <div
                                        className={classes.grid_sub_container}
                                        onClick={()=>{
                                            dispatch(togglePlayerPointsModal({
                                                playerId:data?.id,
                                                matchFixtureId:match_fixture_id,
                                            }));
                                        }}
                                        // onClick={() =>
                                        //     handleModal({
                                        //         match_fixture_id: id,
                                        //         player_id: data?.id,
                                        //     })
                                        // }
                                    >
                                        <div className={classes.image_container}>
                                            <img
                                                src={data?.photo}
                                                alt=""
                                                className={classes.image}
                                            />
                                            <div className={classes.square}>
                                                <p className={classes.point}>
                                                    {data?.point ?? 0}
                                                </p>
                                            </div>
                                            {data?.captain ? (
                                                <div className={classes.square2}>
                                                    <p className={classes.indicate}>{t("46")}</p>
                                                </div>
                                            ) : data?.viceCaptain ? (
                                                <div className={classes.square2}>
                                                    <p className={classes.indicate}>{t("49")}</p>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className={classes.player_name}>
                                            <p className={classes.text}>{data?.name}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div
                            className={classes.grid_container}
                            style={{
                                gridTemplateColumns: `repeat(${midfielders.length}, 1fr)`,
                            }}
                        >
                            {midfielders.map((data) => {
                                return (
                                    <div
                                        className={classes.grid_sub_container}
                                          onClick={()=>{
                                            dispatch(togglePlayerPointsModal({
                                                playerId:data?.id,
                                                matchFixtureId:match_fixture_id,
                                            }));
                                        }}
                                        // onClick={() =>
                                        //     handleModal({
                                        //         match_fixture_id: id,
                                        //         player_id: data?.id,
                                        //     })
                                        // }
                                    >
                                        <div className={classes.image_container}>
                                            <img
                                                src={data?.photo}
                                                alt=""
                                                className={classes.image}
                                            />
                                            <div className={classes.square}>
                                                <p>{data?.point ?? 0}</p>
                                            </div>
                                            {data?.captain ? (
                                                <div className={classes.square2}>
                                                    <p>{t("46")}</p>
                                                </div>
                                            ) : data?.viceCaptain ? (
                                                <div className={classes.square2}>
                                                    <p>{t("49")}</p>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className={classes.player_name}>
                                            <p>{data?.name}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div
                            className={classes.grid_container}
                            style={{
                                gridTemplateColumns: `repeat(${defenders.length}, 1fr)`,
                            }}
                        >
                            {defenders.map((data) => {
                                return (
                                    <div
                                        className={classes.grid_sub_container}

                                          onClick={()=>{
                                            dispatch(togglePlayerPointsModal({
                                                playerId:data?.id,
                                                matchFixtureId:match_fixture_id,
                                            }));
                                        }}

                                        // onClick={() =>
                                        //     handleModal({
                                        //         match_fixture_id: id,
                                        //         player_id: data?.id,
                                        //     })
                                        // }
                                    >
                                        <div className={classes.image_container}>
                                            <img
                                                src={data?.photo}
                                                alt=""
                                                className={classes.image}
                                            />
                                            <div className={classes.square}>
                                                <p>{data?.point ?? 0}</p>
                                            </div>
                                            {data?.captain ? (
                                                <div className={classes.square2}>
                                                    <p>{t("46")}</p>
                                                </div>
                                            ) : data?.viceCaptain ? (
                                                <div className={classes.square2}>
                                                    <p>{t("49")}</p>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className={classes.player_name}>
                                            <p>{data?.name}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div
                            className={classes.grid_container}
                            style={{
                                gridTemplateColumns: `repeat(${goalkeeper.length}, 1fr)`,
                            }}
                        >
                            {goalkeeper.map((data) => {
                                return (
                                    <div
                                        className={classes.grid_sub_container}

                                          onClick={()=>{
                                            dispatch(togglePlayerPointsModal({
                                                playerId:data?.id,
                                                matchFixtureId:match_fixture_id,
                                            }));
                                        }}
                                        
                                        // onClick={() =>
                                        //     handleModal({
                                        //         match_fixture_id: id,
                                        //         player_id: data?.id,
                                        //     })
                                        // }
                                    >
                                        <div className={classes.image_container}>
                                            <img
                                                src={data?.photo}
                                                alt=""
                                                className={classes.image}
                                            />
                                            <div className={classes.square}>
                                                <p>{data?.point ?? 0}</p>
                                            </div>
                                            {data?.captain ? (
                                                <div className={classes.square2}>
                                                    <p>{t("46")}</p>
                                                </div>
                                            ) : data?.viceCaptain ? (
                                                <div className={classes.square2}>
                                                    <p>{t("49")}</p>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className={classes.player_name}>
                                            <p>{data?.name}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyTeam